const { REACT_APP_ENV, REACT_APP_DNS_OPDKV } = process.env

const subdomain = window.location.hostname.split('.')[0]

const hostWithOpenId = () => {
  switch (subdomain) {
    case 'op-dkv-dash':
    case 'dkv_localhost':
      return true
    default:
      return false
  }
}

// dominio

const isDKV = hostWithOpenId()
const isOnline = subdomain !== 'dkv_localhost'

const ssoConfig = {
  local: {
    isDKV: isDKV,
    loginWithOpenId: false,
    sessionStorage: 'oidc.user:https://idsrv4.dev.kubedev01.dkvnet.com:nixi.web',
    configuration: {
      client_id: 'nixi.web',
      client_secret: 'whats.web.secret',
      redirect_uri: 'http://localhost:3001/#/identity-server/callback/',
      response_type: 'code',
      scope: 'openid profile ExtendedProfile whatsapp-resource offline_access',
      authority: 'https://idsrv4.dev.kubedev01.dkvnet.com',
      loadUserInfo: true,
    },
    crmUrl: 'https://dkvseguros-uat.crm4.dynamics.com',
  },
  development: {
    isDKV: isDKV,
    loginWithOpenId: isOnline ? isDKV : false,
    sessionStorage: 'oidc.user:https://idsrv4.uat.kubepro01.dkvnet.com:nixi.web',
    configuration: {
      client_id: 'nixi.web',
      client_secret: 'whats.web.secret',
      redirect_uri: `${REACT_APP_DNS_OPDKV}/#/identity-server/callback/`,
      response_type: 'code',
      scope: 'openid profile ExtendedProfile whatsapp-resource offline_access',
      authority: 'https://idsrv4.uat.kubepro01.dkvnet.com',
      loadUserInfo: true,
    },
    crmUrl: 'https://dkvseguros-uat.crm4.dynamics.com',
  },
  pre: {
    isDKV: isDKV,
    loginWithOpenId: isOnline ? isDKV : false,
    sessionStorage: 'oidc.user:https://idsrv4.uat.kubepro01.dkvnet.com:nixi.web',
    configuration: {
      client_id: 'nixi.web',
      client_secret: 'whats.web.secret',
      redirect_uri: `${REACT_APP_DNS_OPDKV}/#/identity-server/callback/`,
      response_type: 'code',
      scope: 'openid profile ExtendedProfile whatsapp-resource offline_access',
      authority: 'https://idsrv4.uat.kubepro01.dkvnet.com',
      loadUserInfo: true,
    },
    crmUrl: 'https://dkvseguros-uat.crm4.dynamics.com',
  },
  production: {
    isPRO: true,
    isDKV: isDKV,
    loginWithOpenId: isDKV,
    sessionStorage: 'oidc.user:https://idsrv4.pro.kubepro01.dkvnet.com:nixi.web',
    configuration: {
      client_id: 'nixi.web',
      client_secret: 'whats.web.secret',
      redirect_uri: `${REACT_APP_DNS_OPDKV}/#/identity-server/callback/`,
      response_type: 'code',
      scope: 'openid profile ExtendedProfile whatsapp-resource offline_access',
      authority: 'https://idsrv4.pro.kubepro01.dkvnet.com',
      loadUserInfo: true,
    },
    crmUrl: 'https://dkvseguros.crm4.dynamics.com',
  },
}

export default ssoConfig[REACT_APP_ENV]
